import React, { useMemo } from 'react';
import {
  useAppStateCurrentAssetReportStore,
  useAppStateManageAssetReportModalDataStore,
  useAppStatePrevAssetReportStore,
  useAppStateOwnerFilterStore,
} from '../../../common/store/AppStateStore.zustand';
import { getCompareAssetCardData } from '../util/AssetStatusCard.util';
import CompareAssetCardBarChart from './CompareAssetCardBarChart';
import CompareAssetCardAccordion from './CompareAssetCardAccordion';

const CompareAssetCard = () => {
  const { currentAssetReport } = useAppStateCurrentAssetReportStore();
  const { prevAssetReport } = useAppStatePrevAssetReportStore();
  const { manageAssetReportModalData, setManageAssetReportModalData } = useAppStateManageAssetReportModalDataStore();
  const { ownerFilter } = useAppStateOwnerFilterStore();

  const compareAssetCardData = useMemo(() => {
    if (!currentAssetReport || !prevAssetReport) return;
    if (!ownerFilter) return getCompareAssetCardData(currentAssetReport, prevAssetReport);
    const filteredCurrent = { ...currentAssetReport, reportItemList: currentAssetReport.reportItemList.filter((item) => item.owner === ownerFilter) };
    const filteredPrev = { ...prevAssetReport, reportItemList: prevAssetReport.reportItemList.filter((item) => item.owner === ownerFilter) };
    return getCompareAssetCardData(filteredCurrent, filteredPrev);
  }, [currentAssetReport, prevAssetReport, ownerFilter]);

  const handleAssetReportClick = () => {
    setManageAssetReportModalData({ isOpen: true, onClose: () => setManageAssetReportModalData(undefined) });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-all duration-300 group relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-green-600/5 rounded-full -translate-y-32 translate-x-32 group-hover:translate-y-[-8rem] transition-transform duration-500"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-emerald-600/5 rounded-full translate-y-32 -translate-x-32 group-hover:translate-y-[8rem] transition-transform duration-500"></div>
      <div className="flex justify-between items-center mb-6 relative">
        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-1 flex items-center">
            <span>전월 대비 분석</span>
          </h3>
          <p className="text-sm text-gray-500">순자산 변동 현황 및 상세 내역</p>
        </div>
      </div>
      {!compareAssetCardData && (
        <div className="flex flex-col items-center justify-center h-64 bg-gray-50/50 rounded-lg p-6">
          <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4">
            <i className="fas fa-wallet text-3xl text-green-300"></i>
          </div>
          <h4 className="text-lg font-medium text-gray-700 mb-2">비교 데이터가 없습니다</h4>
          <p className="text-sm text-gray-500 text-center max-w-sm">최소 2개월 이상의 자산 데이터가 필요합니다</p>
          <button
            className="mt-6 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-all duration-200 flex items-center space-x-2 !rounded-button whitespace-nowrap"
            onClick={handleAssetReportClick}
          >
            <i className="fas fa-plus"></i>
            <span>자산 추가하기</span>
          </button>
        </div>
      )}
      {compareAssetCardData && (
        <>
          <CompareAssetCardBarChart {...compareAssetCardData} />
          <CompareAssetCardAccordion {...compareAssetCardData} />
        </>
      )}
    </div>
  );
};

export default CompareAssetCard;
